"use client";

import { useEffect } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useHreflang } from "@/i18n/useHreflang";
import HeaderStrip from "./components/HeaderStrip";
import HeroSection from "./components/HeroSection";
import ScopeBanner from "./components/ScopeBanner";
import DisclaimerSections from "./components/DisclaimerSections";
import MapSection from "@/components/feature/MapSection";
import { injectMetaTags } from "@/lib/seoHelpers";

export default function LegalDisclaimerPage() {
  const { currentLang } = useLanguage();
  useHreflang();

  useEffect(() => {
    const isEs = currentLang === "es";
    document.title = isEs
      ? "Aviso Legal y Contacto \u2014 Windows and Doors Repair LLC Miami"
      : "Legal Disclaimer & Contact \u2014 Windows and Doors Repair LLC Miami";

    const desc = isEs
      ? "Aviso legal, alcance del servicio, limitaciones e informaci\u00F3n de contacto. Alcance honesto: solo reparaci\u00F3n, instalaci\u00F3n referida a contratistas con licencia."
      : "Legal disclaimer, service scope, limitations, contact info for Windows and Doors Repair LLC. Honest scope: repair only, installation referred to licensed contractors.";

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", desc);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = desc;
      document.head.appendChild(meta);
    }

    const cleanupSeo = injectMetaTags({
      title: isEs
        ? "Aviso Legal y Contacto \u2014 Windows and Doors Repair LLC Miami"
        : "Legal Disclaimer & Contact \u2014 Windows and Doors Repair LLC Miami",
      description: desc,
      url: "https://impact-window-repair-miami.com/legal-disclaimer/",
      image: "https://impact-window-repair-miami.com/og/og-default.jpg",
      imageAlt: isEs
        ? "Aviso legal Windows and Doors Repair LLC"
        : "Legal disclaimer Windows and Doors Repair LLC",
      breadcrumbs: [
        { name: isEs ? "Inicio" : "Home", item: "https://impact-window-repair-miami.com/" },
        { name: isEs ? "Aviso Legal" : "Legal Disclaimer", item: "https://impact-window-repair-miami.com/legal-disclaimer/" }
      ],
      type: "website",
    });

    const schema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: isEs ? "Aviso Legal y Alcance" : "Legal Disclaimer & Scope",
      description: desc,
      inLanguage: isEs ? "es-US" : "en-US",
      url: "https://impact-window-repair-miami.com/legal-disclaimer/",
      publisher: {
        "@type": "Organization",
        name: "Windows and Doors Repair LLC",
        telephone: "+17863774452",
        email: "contact@impact-window-repair-miami.com",
        address: {
          "@type": "PostalAddress",
          streetAddress: "848 Brickell Ave, PH-5",
          addressLocality: "Miami",
          addressRegion: "FL",
          postalCode: "33131",
          addressCountry: "US",
        },
      },
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      cleanupSeo();
      document.head.removeChild(script);
    };
  }, [currentLang]);

  return (
    <main className="w-full">
      <HeaderStrip />
      <HeroSection />
      <ScopeBanner />
      <DisclaimerSections />
      <MapSection />
    </main>
  );
}